import {UseLoadScriptOptions} from "@react-google-maps/api/dist/useLoadScript";

export const googleMapsLoaderOptions: UseLoadScriptOptions = {
    googleMapsApiKey: 'AIzaSyDt62TlQDwtL1V1qcU4DxGfVMCttImjclk',
    libraries: [ 'places', 'marker' ], // 'marker' is required for AdvancedMarkerElement
};

// Advanced Markers require a Map ID. Set NEXT_PUBLIC_GOOGLE_MAPS_MAP_ID (a build-time
// var: in Vercel for the web, in the CI export step for iOS/Android) to a real Map ID
// from Google Cloud Console (Maps → Map Management). Falls back to Google's 'DEMO_MAP_ID'
// development placeholder. Use `||` (not `??`) so an unset CI variable — which expands to
// an empty string, not undefined — still falls back instead of yielding an empty Map ID.
export const googleMapsMapId = process.env.NEXT_PUBLIC_GOOGLE_MAPS_MAP_ID || 'DEMO_MAP_ID';

export const firebaseConfig = {
    apiKey: 'AIzaSyC3GmmDFALfQwbSrduZmCbNo5ZtkwjZAWg',
    authDomain: 'firetodo2.firebaseapp.com',
    databaseURL: 'https://firetodo2.firebaseio.com',
    projectId: 'firetodo2',
    storageBucket: 'firetodo2.appspot.com',
    messagingSenderId: '719666053613',
    appId: '1:719666053613:web:d1cf826e0d48cb6b6ea7e4',
    measurementId: 'G-QP41YFBEML',
};

export type TestConfig = {
    testUsers: { username: string, password: string }[],
    isTestEnv: boolean | undefined,
};

export const testConfig: TestConfig = {
    testUsers: [],
    isTestEnv: undefined,
};

function loadTestUsers() {
    if (process.env.NEXT_PUBLIC_TEST_USERNAME_0) {
        if (!process.env.NEXT_PUBLIC_TEST_PASSWORD_0) {
            throw Error("NEXT_PUBLIC_TEST_USERNAME_0 specified but NEXT_PUBLIC_TEST_PASSWORD_0 was not!");
        }
        testConfig.testUsers.push({ username: process.env.NEXT_PUBLIC_TEST_USERNAME_0, password: process.env.NEXT_PUBLIC_TEST_PASSWORD_0 });
    }
    if (testConfig.testUsers.length > 0) {
        testConfig.isTestEnv = true;
    } else {
        testConfig.isTestEnv = false;
    }
}
loadTestUsers();
